<ng-container *ngIf="!isServerError">
    <app-all-grades-filters  
        [data]="filtersData" 
        [disabled]="isLoading"
        [isLoading]="!isMainDataLoaded"
        [freeSearchPlaceholder]="data.freeSearchPlaceholder" 
        [searchTerm]="term"
        (searchGrades)="searchGrades($event)"
        (freeSearchChange)="onKeySearch($event)"
    />  

    <span *ngIf="finalGradesData && finalGradesData.length > 0 && !isLoading">
        <span *ngFor="let departmentElement of finalGradesData">

            <div class="table-header">
                <h4 class="table-title">{{getDepartmentName(departmentElement.departmentName)}}</h4>
                <p class="table-description">{{departmentElement.semesterDescription}}</p>
            </div>

            <div class="table-wrap first-table">
                <mat-table [dataSource]="departmentElement.semesterGradesList" multiTemplateDataRows>

                    <ng-container matColumnDef="assignmentText">
                        <mat-cell *matCellDef="let element" class="assignment-text-td phone-tablet-td">
                            <div class="phone-tablet-content">
                                <div class="d-flex align-items-flex-start justify-content-space-between">
                                    {{ element.courseName }}
        
                                    <div class="actions">
                                        <app-dropdown align="end" panelClass="table-dropdown" [width]="170">
                                            <button app-dropdown-trigger class="no-style table-menu">
                                                <mat-icon [svgIcon]="'dots'" class="table-menu-icon"></mat-icon>
                                            </button>
                                            <ng-container *ngFor="let listItem of getFilteredStudentDataTypes(element.dataType)">
                                                <div class="dropdown-list" >
                                                  <a class="dropdown-item" *ngFor="let item of listItem.links" [href]="item.url">{{item.name}}</a>
                                                </div>
                                            </ng-container>
                                        </app-dropdown>
                                    </div>
                                </div>
        
                                <div class="d-flex align-items-center justify-content-space-between indents-cell">
                                    {{ element.inAverageDescription }}
        
                                    <div class="nowrap-text">{{ element.specialCredit }}{{(data.creditsText ? ' ' + data.creditsText : "")}}</div>
                                    <div class="rating-number">{{ element.grade }}</div>
                                </div>
        
                                <div>
                                    <button *ngIf="element.subGrades && element.subGrades.length" class="no-style toggle-children"
                                        (click)="expandedElement = expandedElement === element ? null : element">
                                        {{data.btnExpandItemsText}}
                                        <mat-icon [svgIcon]="expandedElement !== element ? 'plus' : 'minus'"
                                            class="square-icon toggle-children-icon"></mat-icon>
                                    </button>
                                </div>
                            </div>
        
                            <div class="desktop-content">
                                {{ element.courseName }}
                            </div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef class="assignment-text-td phone-tablet-td">
                            <div class="phone-tablet-content">
                                <div class="footer-label">
                                    <strong>{{getTotalDepartmentTitle(departmentElement.departmentName)}}</strong>
                                </div>
                                <div class="d-flex align-items-center justify-content-space-between">
                                    <!-- <div>פרופ׳ נ.סופר-דודק</div> -->
                                    <div></div>
                                    <div class="rating-number">{{departmentElement.specialCreditSum}}</div>
                                    <div class="rating-number">{{departmentElement.gradesSum}}</div>
                                </div>
                            </div>
        
                            <div class="desktop-content">
                                <strong>{{getTotalDepartmentTitle(departmentElement.departmentName)}}</strong>
                            </div>
                        </mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="teacher">
                        <mat-cell *matCellDef="let element" class="teacher-td desktop-td">{{ element.inAverageDescription }}</mat-cell>
                        <!-- <mat-footer-cell *matFooterCellDef class="teacher-td desktop-td">פרופ׳ נ.סופר-דודק</mat-footer-cell> -->
                        <mat-footer-cell *matFooterCellDef class="teacher-td desktop-td"></mat-footer-cell>
                    </ng-container>
        
                    <ng-container matColumnDef="points">
                        <mat-cell *matCellDef="let element" class="points-td desktop-td">
                            <div class="nowrap-text">{{ element.specialCredit }}{{(data.creditsText ? ' ' + data.creditsText : "")}}</div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef class="points-td desktop-td"><strong>{{departmentElement.specialCreditSum}}</strong></mat-footer-cell>
                    </ng-container>
        
                    <ng-container matColumnDef="rating">
                        <mat-cell *matCellDef="let element" class="desktop-td">
                            <div class="rating-number">{{ element.grade }}</div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef class="desktop-td">
                            <div class="rating-number">{{departmentElement.gradesSum}}</div>
                        </mat-footer-cell>
                    </ng-container>
        
                    <ng-container matColumnDef="actions">
                        <mat-cell *matCellDef="let element" class="actions-td desktop-td">
                            <div class="actions">
                                <button *ngIf="element.subGrades && element.subGrades.length" class="no-style toggle-children"
                                    (click)="expandedElement = expandedElement === element ? null : element">
                                    {{data.btnExpandItemsText}}
                                    <mat-icon [svgIcon]="expandedElement !== element ? 'plus' : 'minus'"
                                        class="square-icon toggle-children-icon"></mat-icon>
                                </button>
        
                                <app-dropdown align="end" panelClass="table-dropdown" [width]="170">
                                    <button app-dropdown-trigger class="no-style table-menu">
                                        <mat-icon [svgIcon]="'dots'" class="table-menu-icon"></mat-icon>
                                    </button>
                                    <ng-container app-dropdown-content>
                                        <ng-container *ngFor="let listItem of getFilteredStudentDataTypes(element.dataType)">
                                            <div class="dropdown-list" >
                                              <a class="dropdown-item" *ngFor="let item of listItem.links" [href]="item.url">{{item.name}}</a>
                                            </div>
                                          </ng-container>
                                    </ng-container>
                                </app-dropdown>
                            </div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef class="desktop-td"></mat-footer-cell>
                    </ng-container>

                    <ng-container matColumnDef="expandedColumn">
                        <mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="details-td">
                            <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'" class="details-box">
                                <table class="sub-table">
                                        <ng-container *ngFor="let subTd of element.subGrades">
                                            <tr class="sub-tr" [ngStyle]="{ '--td-border': getRowColor(subTd.dataType) }">
                                                <td class="sub-td title-td">
                                                    <button *ngIf="subTd.subGrades && subTd.subGrades.length"
                                                        class="no-style toggle-children"
                                                        (click)="expandedSubElement = expandedSubElement === subTd ? null : subTd">
                                                        <mat-icon [svgIcon]="expandedSubElement !== subTd ? 'plus' : 'minus'"
                                                            class="square-icon toggle-children-icon"></mat-icon>
                                                        {{ subTd.courseName }}
                                                    </button>
                                                    <span *ngIf="!(subTd.subGrades && subTd.subGrades.length)">{{ subTd.courseName }}</span>
                                                </td>
                                                <!-- <td class="sub-td points-td">{{ subTd.percentage }}</td> -->
                                                <td class="sub-td points-td">
                                                    <a *ngIf="subTd.dataType == 3 && subTd.gradeLink" [href]="subTd.gradeLink" target="_blank">{{data.examToGradeLinkText}}</a>
                                                </td>
                                                <td class="sub-td">
                                                    <div *ngIf="subTd.dataType == 3" class="actions">
                                                        <!-- <a [href]="subTd.gradeLink" target="_blank">לצפייה בציונים</a> -->
                                                        <div></div>
            
                                                        <app-dropdown align="end" panelClass="table-dropdown" [width]="170">
                                                            <button app-dropdown-trigger class="no-style table-menu">
                                                                <mat-icon [svgIcon]="'dots'" class="table-menu-icon"></mat-icon>
                                                            </button>
                                                            <ng-container app-dropdown-content>
                                                                <ng-container *ngFor="let listItem of getFilteredStudentDataTypes(element.dataType)">
                                                                    <div class="dropdown-list" >
                                                                      <a class="dropdown-item" *ngFor="let item of listItem.links" [href]="item.url">{{item.name}}</a>
                                                                    </div>
                                                                  </ng-container>
                                                            </ng-container>
                                                        </app-dropdown>
                                                    </div>
                                                    <span *ngIf="subTd.dataType != 3">{{ subTd.grade }}</span>
                                                </td>
                                            </tr>
            
                                            <tr *ngIf="subTd.subGrades && subTd.subGrades.length" class="sub-tr">
                                                <td [attr.colspan]="3" class="details-td">
                                                    <div [@detailExpand]="subTd == expandedSubElement ? 'expanded' : 'collapsed'" class="details-box">
                                                        <table class="sub-table">
                                                            <ng-container *ngFor="let sub2Td of subTd.subGrades">
                                                                <tr class="sub-tr" [ngStyle]="{ '--td-border': getRowColor(sub2Td.dataType) }">
                                                                    <td class="sub-td title-td">{{ sub2Td.courseName }}</td>
                                                                    <!-- <td class="sub-td points-td">{{ sub2Td.percentage }}</td> -->
                                                                    <td class="sub-td points-td"></td>
                                                                    <td class="sub-td">{{ sub2Td.grade }}</td>
                                                                </tr>
                                                            </ng-container>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </table>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-row *matRowDef="let row; columns: displayedColumns;"[class.expanded-row]="expandedElement === row"></mat-row>
                    <mat-row *matRowDef="let row; columns: ['expandedColumn']" class="details-row"></mat-row>
                    <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
                </mat-table>
            </div>

        </span>
    </span>



    <span *ngIf="isLoading && !isServerError">
        <span *ngFor="let _ of [].constructor(2)">

            <div class="table-header">
                <div>
                    <app-skeleton [type]="'text'" [symbolsCount]="14" class="table-title" />
                </div>
                <app-skeleton [type]="'text'" [symbolsCount]="10" class="table-description" />
            </div>

            <div class="table-wrap first-table">
                <div class="skeleton-table-item" *ngFor="let _ of [].constructor(4)">
                    <app-skeleton/>
                </div>
            </div>

        </span>
    </span>



    <span *ngIf="(!finalGradesData || finalGradesData.length == 0) && !isLoading">
        <div class="no-grades-results-text">{{data.noResultData}}</div>
    </span>
</ng-container>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>